import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./TileAction.html';
import styles from './tile-action-hashed.scss';
import layout from '../../../layouts/LayoutFactory';

export default layout('TileAction', template, (partial) => {
    partial('Item', cssUtil.hashTemplate('<div class="<%= gwTileActionItem %>" gw-partial-target></div>', styles));
});
